<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('stock_transfer') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/stock/transfer" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <div class="pull-right">
                <div class="form-group">
                    <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('from_date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="query.FromDate" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('to_date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="query.ToDate" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">&nbsp;</label>
                                <div>
                                    <button type="button" class="btn btn-default btn-sm" @click="toList"><i aria-hidden="true" class="fa fa-search"></i> {{$t('search')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                            <th>{{ $t('code') }}</th>
                            <th>{{$t('date')}}</th>
                            <th>{{$t('branch_from')}}</th>
                            <th>{{$t('branch_to')}}</th>
                            <th>{{$t('description')}}</th>
                            <th>{{$t('status')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret, index) in list" :key="index">
                            <td>{{index+1}}</td>
                            <td><router-link :to="{name:'stock_transfer_preview', params: {id:ret.Id}}">{{ret.Num}}</router-link></td>
                            <td>{{$format(ret.Date,'DD-MM-YYYY')}}</td>
                            <td>{{ret.FromBranchName}}</td>
                            <td>{{ret.ToBranchName}}</td>
                            <td>{{ret.Remark}}</td>
                             <td class="cell-badge" v-html="$statusLabel(ret.IsApproved?'Posted':'Draft')"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                query:{
                    Text: '',
                    FromDate: '',
                    ToDate: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25
                },
                list: []
            }
        },
        mounted(){
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.$api().post('stock/transfers', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.list = res.data.Json.StockTransfers;
                        this.query.Total = res.data.Total;
                    }
                }).finally(function() { loading.hide();});
            }
        }
    }
</script>